import apiClient from "../api/client";

export interface Notification {
  id: string;
  user: string;
  titre: string;
  message: string;
  type: "info" | "success" | "warning" | "error";
  lue: boolean;
  lien: string | null;
  timestamp: string;
}

export interface PaginatedNotifications {
  count: number;
  next: string | null;
  previous: string | null;
  results: Notification[];
}

export const NotificationService = {
  async getNotifications(page = 1): Promise<PaginatedNotifications> {
    const response = await apiClient.get<PaginatedNotifications>(
      `/auth/notifications/?page=${page}&ordering=-timestamp`
    );
    return response.data;
  },

  async getUnreadCount(): Promise<number> {
    try {
      const response = await apiClient.get<{ count: number }>(
        "/auth/notifications/non_lues_count/"
      );
      return response.data.count;
    } catch {
      // Fallback: fetch first page and count unread
      const data = await NotificationService.getNotifications(1);
      return data.results.filter((n) => !n.lue).length;
    }
  },

  async markAsRead(id: string): Promise<void> {
    await apiClient.post(`/auth/notifications/${id}/marquer_lue/`);
  },

  async markAllAsRead(): Promise<{ count: number }> {
    const response = await apiClient.post<{ count: number }>(
      "/auth/notifications/tout_marquer_lu/"
    );
    return response.data;
  },
};
